import IntroSection from './IntroSection/IntroSection';
import Qualities from './Qualities/Qualities';
import Features from './Features/Features';
import FAQ from './FAQ/FAQ';
import CTA from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';
import { Fade } from 'react-reveal';

const Home = () => {
  return (
    <Fade duration={250}>
      <div>
        <IntroSection />
        <Qualities />
        <Features />
        <FAQ />
        <Footer />
      </div>{' '}
    </Fade>
  );
};

export default Home;
